<template>
  <div class="dropdown-content">
    <div class="field-name">
      <p class="dropdown">{{ fieldName }}{{ isMandatory ? '*' : '' }}</p>
      <p v-if="description" class="description-info">
        <span class="tooltip" role="tooltip" aria-describedby="tooltip1">
          <i class="icon icon-info"></i>
          <span class="message top-end" id="tooltip1">{{ description }}</span>
        </span>
      </p>
    </div>
    <div class="dropdown dropdown-item" data-type="click" ref="dropdown">
      <button class="btn clickable" :class="{'error-text': !isValid && isMandatory}" @click="preventDefault">
        {{ defaultValue }}
      </button>
      <div class="menu">
        <div v-if="isSearch" class="item sticky-item">
          <input
            type="text"
            class="with-icon"
            placeholder="Search for..."
            @click="(ev) => ev.stopPropagation()"
            @input="onSearchData" />
          <div class="suffix icon-inside"><i class="icon icon-search"></i></div>
          <p v-if="helpText" class="help-text">* {{ helpText }}</p>
        </div>
        <div
          v-for="item in searchItems"
          :key="item"
          class="item"
          @click="changeValue" >
          {{ item }}
        </div>
      </div>
      <div 
        v-if="isClearField"
        class="btn icon-btn icon icon-trashcan tooltip"
        role="tooltip"
        aria-describedby="tooltip1"
        @click="clearField">
        <label class="message bottom" id="tooltip1">Clear field</label>
      </div>
    </div>
    
  </div>
</template>

<script>
import { Dropdown } from '@eds/vanilla';

export default {
  data() {
    return {
      dropdown: Dropdown,
      defaultValue: 'Select value',
      searchItems: [],
    };
  },

  props: {
    fieldName: {
      type: String,
      required: true,
    },

    optionItems: {
      type: Array,
    },

    selectValue: {
      type: String,
      default: '',
    },

    isSearch: {
      type: Boolean,
      default: false,
    },

    isAddNewValue: {
      type: Boolean,
      default: false
    },

    isClearField: {
      type: Boolean,
      default: false
    },

    description: {
      type: String,
      default: null
    },

    helpText: {
      type: String,
      default: null
    },

    isMandatory: {
      type: Boolean,
      default: false
    },

    isValid: {
      type: Boolean,
      default: false
    }
  },

  mounted() {
    this.searchItems = this.optionItems;
    this.initDropdown();
  },

  methods: {
    initDropdown() {
      const dropdown = this.$refs.dropdown;
      this.dropdown = new Dropdown(dropdown);
      this.dropdown.init();

      if (this.selectValue) {
        this.defaultValue = this.selectValue;
      }
    },

    preventDefault(event) {
      event.preventDefault();
    },

    changeValue(event) {
      this.defaultValue = event.target.textContent;
      this.$emit('changeValue', this.defaultValue);
    },

    onSearchData(ev) {
      if (ev.target.value) {
        this.searchItems = this.optionItems.filter((item) =>
          item.toLowerCase().includes(ev.target.value.toLowerCase())
        );

        if (this.searchItems.length === 0 && this.isAddNewValue) {
          this.defaultValue = ev.target.value;
          this.$emit('changeValue', this.defaultValue);
        }
      } else {
        this.searchItems = this.optionItems;
      }
    },

    clearField() {
      this.defaultValue = 'Select value';
      this.$emit('changeValue', '');
    }
  },
};
</script>

<style scoped lang="less">
@import '~@eds/vanilla/variables/global.less';
@import '~@eds/vanilla/variables/dark.less';

.dropdown-content {
  display: grid;
  padding: 2rem;
}

.sticky-item {
  position: sticky;
  top: 0;
  background-color: @gray-31;
}

.dropdown-item,
.with-icon {
  width: -webkit-fill-available;
}

.field-name {
  display: flex;
}

.description-info {
  margin-left: 1rem;

  .icon-info {
    cursor: pointer;
  }
}

.help-text {
  margin-left: 0.5rem;
  margin-top: 0.5rem;
  font-size: 0.8rem;
  font-style: italic;
  white-space: normal;
}

.menu {
  max-width: inherit;
  max-height: 250px !important;
}

.error-text {
  border-color: @red-52;
}
</style>